module.exports = __webpack_public_path__ + "media/images/lp/icn_tel_01-6d69d0c461046967f9810b9e27b514ba.svg";